export default __webpack_public_path__ + "static/media/menu-button.bb78b14e.svg";